<template>
  <div style="padding: 10px">
    <div style="display: flex; justify-content: flex-end">
      <el-form :inline="true" size="small">
        <el-form-item label-width="0">
          <el-input
            v-model="searchLicensePlate"
            placeholder="搜索车牌号"
          ></el-input>
        </el-form-item>
        <el-form-item label-width="0">
          <el-select v-model="searchStatus" placeholder="选择充电状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="充电中" value="charging"></el-option>
            <el-option label="空闲" value="idle"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" @click="onSubmit">{{
            $t("public.query")
          }}</el-button>
          <el-button type="success" @click="openDialog">提醒设置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row :gutter="20">
      <el-col :span="6" v-for="(car, index) in filteredCarList" :key="index">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>{{ car.licensePlate }}</span>
            <el-tag :type="car.status === 'charging' ? 'primary' : 'warning'">{{
              car.status
            }}</el-tag>
          </div>
          <div v-if="car.status === 'charging'">
            <p>当前电量: {{ car.currentBattery }}%</p>
            <p>续航里程: {{ car.range }} 公里</p>
            <p>总电压: {{ car.totalVoltage }} V</p>
            <p>总电流: {{ car.totalCurrent }} A</p>
            <el-progress :percentage="car.currentBattery"></el-progress>
            <p>预计充满时间: {{ car.estimatedTime }}</p>
            <el-button @click="disconnectCharging(index)">断开充电</el-button>
          </div>
          <div v-else>
            <p>车辆未在充电状态。</p>
            <p>续航里程: {{ car.range }} 公里</p>
            <p>总电压: {{ car.totalVoltage }} V</p>
            <p>总电流: {{ car.totalCurrent }} A</p>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div style="display: flex; justify-content: flex-end">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[4]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next"
        :total="filteredCarList.length"
      >
      </el-pagination>
    </div>
    <el-dialog :visible.sync="dialogVisible" title="充电提醒设置">
      <el-form :model="chargeSettings" label-width="140px">
        <el-form-item label="满电阈值（0-100）">
          <el-input
            v-model.number="chargeSettings.fullChargeThreshold"
            min="0"
            max="100"
          ></el-input>
        </el-form-item>
        <el-form-item label="亏电阈值（0-100）">
          <el-input
            v-model.number="chargeSettings.lowChargeThreshold"
            min="0"
            max="100"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱地址">
          <el-input v-model="chargeSettings.email"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="chargeSettings.phoneNumber"></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="chargeSettings.notifyByPlatform"
            >平台提醒</el-checkbox
          >
          <el-checkbox v-model="chargeSettings.notifyByEmail"
            >邮件提醒</el-checkbox
          >
          <el-checkbox v-model="chargeSettings.notifyBySMS"
            >短信提醒</el-checkbox
          >
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer"><el-button @click="closeDialog">取消</el-button>
        <el-button @click="saveSettings" type="primary">保存设置</el-button>
        
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "CarChargingStatus",
  data() {
    return {
      dialogVisible: false,
      chargeSettings: {
        fullChargeThreshold: 90, // 满电阈值，可修改
        lowChargeThreshold: 20, // 亏电阈值，可修改
        email: "", // 存储用户输入的邮箱
        phoneNumber: "", // 存储用户输入的手机号
        notifyByPlatform: false, // 是否通过平台提醒
        notifyByEmail: false, // 是否通过邮件提醒
        notifyBySMS: false, // 是否通过短信提醒
      },
      carList: [
        {
          licensePlate: "粤A12345",
          status: "charging",
          currentBattery: 50,
          estimatedTime: "1小时30分钟",
          range: 200, // 新增续航里程
          totalVoltage: 400, // 新增总电压
          totalCurrent: 10, // 新增总电流
        },
        {
          licensePlate: "粤B67890",
          status: "idle",
          currentBattery: 80,
          estimatedTime: "",
          range: 300,
          totalVoltage: 380,
          totalCurrent: 0,
        },
        // 添加更多车辆信息，使总数达到 8 条
        {
          licensePlate: "粤C23456",
          status: "charging",
          currentBattery: 30,
          estimatedTime: "2小时",
          range: 150,
          totalVoltage: 410,
          totalCurrent: 12,
        },
        {
          licensePlate: "粤D34567",
          status: "idle",
          currentBattery: 70,
          estimatedTime: "",
          range: 250,
          totalVoltage: 390,
          totalCurrent: 0,
        },
        {
          licensePlate: "粤E45678",
          status: "charging",
          currentBattery: 60,
          estimatedTime: "1小时",
          range: 220,
          totalVoltage: 405,
          totalCurrent: 11,
        },
        {
          licensePlate: "粤F56789",
          status: "idle",
          currentBattery: 90,
          estimatedTime: "",
          range: 320,
          totalVoltage: 375,
          totalCurrent: 0,
        },
        {
          licensePlate: "粤G67890",
          status: "charging",
          currentBattery: 40,
          estimatedTime: "2小时30分钟",
          range: 180,
          totalVoltage: 415,
          totalCurrent: 13,
        },
        {
          licensePlate: "粤H78901",
          status: "idle",
          currentBattery: 85,
          estimatedTime: "",
          range: 280,
          totalVoltage: 385,
          totalCurrent: 0,
        },
      ],
      currentPage: 1,
      pageSize: 4,
      searchLicensePlate: "",
      searchStatus: "",
    };
  },
  computed: {
    filteredCarList() {
      let tempList = this.carList;
      if (this.searchLicensePlate) {
        tempList = tempList.filter((car) =>
          car.licensePlate.includes(this.searchLicensePlate)
        );
      }
      if (this.searchStatus) {
        tempList = tempList.filter((car) => car.status === this.searchStatus);
      }
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return tempList.slice(start, end);
    },
  },
  methods: {
    openDialog() {
      this.dialogVisible = true;
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    saveSettings() {
      this.closeDialog();
      // 这里可以添加逻辑对输入数据进行验证，确保数据的有效性
    },
    checkChargeLevel(chargeLevel) {
      if (chargeLevel >= this.chargeSettings.fullChargeThreshold) {
        this.sendFullChargeReminder();
      } else if (chargeLevel <= this.chargeSettings.lowChargeThreshold) {
        this.sendLowChargeReminder();
      }
    },
    sendFullChargeReminder() {
      let message = `您的设备已充满电（超过${this.chargeSettings.fullChargeThreshold}%），请及时拔掉电源。`;
      if (this.chargeSettings.notifyByPlatform) {
        // 调用平台提醒的 API 或逻辑，这里仅作示例，需要根据实际情况实现
        console.log(message);
      }
      if (this.chargeSettings.notifyByEmail) {
        // 调用发送邮件的服务，例如使用 Node.js 的 nodemailer，这里仅作示例，需要根据实际情况实现
        console.log(`发送邮件到 ${this.chargeSettings.email}: ${message}`);
      }
      if (this.chargeSettings.notifyBySMS) {
        // 调用发送短信的服务，例如使用短信服务提供商的 SDK，这里仅作示例，需要根据实际情况实现
        console.log(
          `发送短信到 ${this.chargeSettings.phoneNumber}: ${message}`
        );
      }
    },
    sendLowChargeReminder() {
      let message = `您的设备电量过低（低于${this.chargeSettings.lowChargeThreshold}%），请及时充电。`;
      if (this.chargeSettings.notifyByPlatform) {
        // 调用平台提醒的 API 或逻辑，这里仅作示例，需要根据实际情况实现
        console.log(message);
      }
      if (this.chargeSettings.notifyByEmail) {
        // 调用发送邮件的服务，例如使用 Node.js 的 nodemailer，这里仅作示例，需要根据实际情况实现
        console.log(`发送邮件到 ${this.chargeSettings.email}: ${message}`);
      }
      if (this.chargeSettings.notifyBySMS) {
        // 调用发送短信的服务，例如使用短信服务提供商的 SDK，需要根据实际情况实现
        console.log(
          `发送短信到 ${this.chargeSettings.phoneNumber}: ${message}`
        );
      }
    },
    disconnectCharging(index) {
      // 在这里添加你断开充电的逻辑，比如调用 API 或者修改数据
      this.carList[index].status = "idle";
      this.carList[index].estimatedTime = "";
      console.log(`已断开车辆 ${this.carList[index].licensePlate} 的充电`);
    },
    handleSizeChange(size) {
      this.pageSize = size;
    },
    handleCurrentChange(page) {
      this.currentPage = page;
    },
  },
};
</script>

<style scoped>
.box-card {
  width: 100%;
  margin-bottom: 20px;
}
</style>
